import React from 'react';
import { Box, Typography, Divider, Chip } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { channelInfoAtom } from '../../../../Services/_states';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const ProfileContent: React.FC = () => {
  const channelInfo = useRecoilValue(channelInfoAtom);

  if (!channelInfo) {
    return (
      <Box sx={{ padding: 4 }}>
        <Typography variant="h6" color="textSecondary">
          No app details available.
        </Typography>
      </Box>
    );
  }

  const isActive =
    channelInfo?.is_active === true || channelInfo?.status === 'active';

  const fields: { label: string; value: any }[] = [
    { label: 'Display Name', value: channelInfo?.app_name },
    { label: 'Phone Number', value: channelInfo?.wa_phone_number },
    { label: 'Phone Number ID', value: channelInfo?.wa_phone_number_id },
    { label: 'WABA ID', value: channelInfo?.waba_id },
    { label: 'App ID', value: channelInfo?.app_id },
    { label: 'Business Entity Name', value: channelInfo?.app_type },
    { label: 'Company Name', value: channelInfo?.company_name },
    { label: 'Company ID', value: channelInfo?.company_id },
    { label: 'Source', value: channelInfo?.source },
    { label: 'API Version', value: channelInfo?.wa_version },
    { label: 'Messaging Product', value: channelInfo?.wa_messaging_product },
    { label: 'Recipient Type', value: channelInfo?.wa_recipient_type },
  ].filter((f) => f.value !== undefined && f.value !== null && f.value !== '');

  return (
    <Box
      sx={{
        padding: 4,
        backgroundColor: '#f9fafb',
        borderRadius: 2,
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        maxWidth: '100%',
        margin: '0 auto',
      }}
    >
      {/* Title + Status */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <Typography variant="h5" fontWeight="bold">
          WABA Details
        </Typography>
        <Chip
          label={isActive ? 'Live' : 'Not Live'}
          icon={
            isActive ? (
              <CheckCircleIcon sx={{ color: 'green', fontSize: 16 }} />
            ) : (
              <CancelIcon sx={{ color: 'red', fontSize: 16 }} />
            )
          }
          sx={{
            backgroundColor: isActive ? '#c8e6c9' : '#ffebee',
            color: isActive ? 'green' : 'red',
            fontWeight: 'bold',
          }}
        />
      </Box>

      <Typography color="textSecondary" mb={3} variant="body2">
        These are your WABA account details approved by WhatsApp. These are
        non-editable and some will be shown in your WhatsApp business profile.
      </Typography>

      <Divider sx={{ mb: 3 }} />

      <Box
        display="grid"
        gridTemplateColumns={{ xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr' }}

        gap={2}
      >
        {fields.map(({ label, value }) => (
          <Box key={label}>
            <Typography variant="caption" color="textSecondary" display="block">
              {label}
            </Typography>
            <Typography variant="body2" fontWeight={500}>
              {String(value)}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Webhook info if present */}
      {channelInfo?.webhook && (
        <>
          <Divider sx={{ my: 3 }} />
          <Typography variant="subtitle1" fontWeight="bold" mb={1}>
            Webhook Info
          </Typography>
          <Box display="grid" gridTemplateColumns={{ xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr' }}
            gap={2}>
            <Box>
              <Typography variant="caption" color="textSecondary" display="block">
                Callback URL
              </Typography>
              <Typography
                variant="body2"
                fontWeight={500}
                sx={{ wordBreak: 'break-all' }}
              >
                {channelInfo.webhook.callback_url || 'N/A'}
              </Typography>
            </Box>
            <Box>
              <Typography variant="caption" color="textSecondary" display="block">
                Webhook Registered
              </Typography>
              <Typography
                variant="body2"
                fontWeight={500}
                color={channelInfo.webhook.registered ? 'green' : 'red'}
              >
                {channelInfo.webhook.registered ? 'Yes' : 'No'}
              </Typography>
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
};

export default ProfileContent;